import { type ReactNode } from 'react';
import { Box } from '@mantine/core';

type Props = {
  children: ReactNode;
};

export const PropertiesContent = ({ children }: Props) => {
  return (
    <Box sx={theme => ({ marginTop: theme.other.spacing(4) })}>{children}</Box>
  );
};
